import {
  getTemplateFirstChild,
  parseHTML,
  replaceNodeChildren,
} from '../../utils/dom'
import { BaseComponent } from '../../components/base-component'
import { hideElement, showElement } from '../../utils/dom'
import { BodyElement } from 'src/scripts/components/body-element/body-element'
import { $el, $list } from 'src/scripts/utils/utils'

const LOADING_OVERLAY_SELECTOR = '.loading-overlay'
const IN_CART_RELATED_PRODUCTS_SELECTOR = '[in-cart-related-product]'
const CART_DRAWER_TEMPLATE_SELECTOR = '[data-sidebar-template="CartDrawer"]'
const BODY_ELEMENT_SELECTOR = 'body-element'

export class CartDrawerRelatedProducts extends BaseComponent {
  prevUrl: string

  mountComponent(): void {
    this.loadProducts()
  }

  erase(): void {
    this.replaceChildren()
    this.setReady(false)
  }

  loadProducts() {
    if (this.prevUrl === this.dataset.url) {
      return
    }

    this.prevUrl = this.dataset.url

    if (!this.dataset.url) {
      return
    }

    this.showPreloader()

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        this.hidePreloader()

        const html = parseHTML(text)
        const template = $el(CART_DRAWER_TEMPLATE_SELECTOR, html)
        const node = getTemplateFirstChild(template)

        this.updateByHTML(node)
      })
      .catch(() => {
        const bodyElement: BodyElement = $el(BODY_ELEMENT_SELECTOR)

        bodyElement.showNotification(
          'Error in cart drawer related products',
          'warning',
        )
      })
  }

  updateByHTML = (node: HTMLElement): void => {
    const recommendations = $el(`#${this.id}`, node)
    replaceNodeChildren(this, recommendations)

    const products = $list(IN_CART_RELATED_PRODUCTS_SELECTOR, this)
    this.setReady(products.length > 0)
  }

  setReady(isReady: boolean): void {
    this.toggleAttribute('is-ready', isReady)
  }

  showPreloader(): void {
    const preloader = $el(LOADING_OVERLAY_SELECTOR, this)
    showElement(preloader)
  }

  hidePreloader(): void {
    const preloader = $el(LOADING_OVERLAY_SELECTOR, this)
    hideElement(preloader)
  }
}
